import { AppRoute, isPPDeprecated } from "./shared";

import { BattleGroupReview } from "@/pages/Admin/BattleGroups/BattleGroupReview";
import { PointsCompare } from "@/pages/Admin/Points/PointsCompare";
import { Apps } from "@/pages/Apps/Apps";
import { Bridge } from "@/pages/Bridge/Bridge";
import { DailySpin } from "@/pages/DailySpin/DailySpin";
import { GuardiansOfPlume } from "@/pages/GuardiansOfPlume/GuardiansOfPlume";
import { Home } from "@/pages/Home/Home";
import { Leaderboard } from "@/pages/Leaderboard/Leaderboard";
import { Profile } from "@/pages/Profile/Profile";
import { QuestDetails } from "@/pages/QuestDetails/QuestDetails";
import { Quests } from "@/pages/Quests/Quests";
import { SeasonOneClaim } from "@/pages/SeasonClaim/SeasonOneClaim";
import { Swap } from "@/pages/swap/Swap";

export type TAppRoute = {
  path: AppRoute;
  element: React.ComponentType;
  devOnly?: boolean;
  ppDeprecated?: boolean;
};

const ALL_ROUTES: TAppRoute[] = [
  { path: AppRoute.Home, element: Home },
  { path: AppRoute.Quests, element: Quests, ppDeprecated: true },
  { path: AppRoute.QuestDetails, element: QuestDetails, ppDeprecated: true },
  { path: AppRoute.Apps, element: Apps },
  // Don't treat MyProfile as a separate route, we treat /me as a route param
  { path: AppRoute.Profile, element: Profile },
  { path: AppRoute.Leaderboard, element: Leaderboard, ppDeprecated: true },
  { path: AppRoute.DailySpin, element: DailySpin },
  { path: AppRoute.Swap, element: Swap },
  { path: AppRoute.Bridge, element: Bridge },
  { path: AppRoute.SeasonOneClaim, element: SeasonOneClaim },
  { path: AppRoute.AdminPointsCompare, element: PointsCompare },
  { path: AppRoute.AdminBattleGroupReview, element: BattleGroupReview },
  { path: AppRoute.AppDetail, element: Apps },
  {
    path: AppRoute.GuardiansOfPlume,
    element: GuardiansOfPlume,
    devOnly: true,
    ppDeprecated: true,
  },
];

export const APP_ROUTES: TAppRoute[] = ALL_ROUTES.filter(
  (route) => !isPPDeprecated || !route.ppDeprecated,
);
